/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';
// template components
import HeroSection from '@nmx/template/dist/componentLibrary/modules/HeroSection';

export const HeroSectionStyled = styled(HeroSection)`
  .hero-section-bg-image-container {
    background-position-x: center;
    background-position-y: top;
  }
`;
